import { render, staticRenderFns } from "./phoneCard.vue?vue&type=template&id=0bf62bfc"
import script from "./phoneCard.vue?vue&type=script&lang=js"
export * from "./phoneCard.vue?vue&type=script&lang=js"
import style0 from "./phoneCard.vue?vue&type=style&index=0&id=0bf62bfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports